import classes from './NotificationComponent.module.css'
import { useDispatch } from "react-redux";
import { notificationActions } from '../../store/notifications';

const NotificationItem = ({children, id, type, timeOut}) => {
    const dispatch = useDispatch()

    const closeWarning = () => {
        dispatch(notificationActions.removeError(id))
    }
    setTimeout(() => {
        dispatch(notificationActions.removeError(id))
    }, timeOut || 3000);


    return <div className={`${classes.warning} ${type && type == 'success' && classes.success}`}>
        <div className={classes.warning_inner}>
            
            <div className={classes.text_wrapper}>
                
                {!type && <div className={classes.warning_icon}>
                    <i className='ti ti-exclamation-circle'></i>
                </div>}
                {type && type == 'success' && <div className={`${classes.warning_icon} ${classes.icon_success}`}>
                    <i className='ti ti-circle-check'></i>
                </div>}
                <div>
                    {!type && <div className={classes.text_title}>Error Message</div>}
                    {type && type == 'success' && <div className={classes.text_title}>Information Updated</div>}
                    <div className={classes.warning_text}>
                        {children}
                    </div>
                </div>
            </div>

            <div>
                <button onClick={closeWarning} className={classes.close_button}>
                    Okay!
                    <span className='sr-only'>close warning</span>
                </button>
            </div>
        </div>
    </div>
}

export default NotificationItem 